import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from 'components/commons/loading/Loading';
import { PremiumCheck2 as PremiumCheck } from 'components/commons/premium-check/PremiumCheck';
import { Mode } from './TargetUpdateStep1';
import { TargetPremium } from '../components/features/TargetPremium';
import { TargetUpdateConfirmNew } from '../components/features/update/confirm/TargetUpdateConfirmNew';
import { TargetUpdateConfirmEdit } from '../components/features/update/confirm/TargetUpdateConfirmEdit';
import { useGlobalMenuContext } from 'contexts/GlobalMenuContext';

const TargetUpdateConfirm = (): React.ReactElement => {
  const { id, mode } = useParams<{ id: string; mode: Mode }>();

  const { setIsShowMenu } = useGlobalMenuContext();
  useEffect(() => {
    return setIsShowMenu(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (mode) {
    case 'new':
      return (
        <PremiumCheck content={<TargetPremium />}>
          <TargetUpdateConfirmNew {...{ id, mode }} />
        </PremiumCheck>
      );
    case 'edit':
      return (
        <PremiumCheck content={<TargetPremium />}>
          <TargetUpdateConfirmEdit {...{ id, mode }} />
        </PremiumCheck>
      );
    default:
      return <Loading loading style={{ marginTop: '3rem' }} />;
  }
};

export default TargetUpdateConfirm;
